import { render, staticRenderFns } from "./CoinRule.vue?vue&type=template&id=2664fa7e&scoped=true"
import script from "./CoinRule.vue?vue&type=script&lang=js"
export * from "./CoinRule.vue?vue&type=script&lang=js"
import style0 from "./CoinRule.vue?vue&type=style&index=0&id=2664fa7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2664fa7e",
  null
  
)

export default component.exports